'use client';

import { Button } from '@nf/ui';
import Image from 'next/image';
import { actionStyle as style } from './action.style';
import { jupiterButton } from 'styled-system/recipes';
import { appDownloadService } from '@/services/jupiter/app-download-service';
import { useAthenaSiteConfig } from '@/hooks/query/athena/use-athena-site-config';
import { useTranslations } from 'next-intl';
import { signUpService } from '@/services/sign-up.service';
import * as QRCode from 'qrcode';
import { useEffect, useState } from 'react';
import { useAuthToken } from '@/store/auth';

export const Action = () => {
	const { data: athenaSiteConfig } = useAthenaSiteConfig();
	const [qrCodeUrl, setQRCodeUrl] = useState('');
	const t = useTranslations('General');
	const authToken = useAuthToken();
	const isBefore = !Boolean(authToken);

	const generateQrCode = async (url?: string) => {
		if (!url) return;

		const dataUrl = await QRCode.toDataURL(url);
		setQRCodeUrl(dataUrl);
	}

	useEffect(() => {
		generateQrCode(athenaSiteConfig?.DownloadAPPUrl);
	}, [athenaSiteConfig?.DownloadAPPUrl])

	return (
		<section data-name="action" className={style.action}>
			{athenaSiteConfig?.DownloadAPPUrl ? (
				<div className={style.actionItem}>
					<div className={style.actionInfo}>
						<div className={style.qrcode}>
							{qrCodeUrl ? (
								<Image
									src={qrCodeUrl}
									width={93}
									height={93}
									alt=""
								/>
							) : null}
						</div>
						<div className={style.title}>{t('lbl_MobileAPPDownload')}</div>
						<div className={style.button}>
							<Button
								className={jupiterButton()}
								onClick={() => appDownloadService.openAppDownload(athenaSiteConfig.DownloadAPPUrl)}
							>
								{t('lbl_download')}
							</Button>
						</div>
					</div>
					<div className={style.actionImage}>
						<BackgroundImage />
						<div className={style.android}>
							<svg xmlns="http://www.w3.org/2000/svg" width="87" height="94" fill="none" viewBox="0 0 87 94">
								<path fill="var(--colors-jupiter-site-primary-fixed)" d="M52.94 88.386V74.903h-7.575v13.483a5.796 5.796 0 0 1-1.604 3.973A5.3 5.3 0 0 1 39.948 94a5.299 5.299 0 0 1-3.814-1.641 5.795 5.795 0 0 1-1.603-3.973V74.903h-8.136c-.487 0-.955-.203-1.3-.563a1.967 1.967 0 0 1-.537-1.359v-40.01c0-.51.193-.998.538-1.359.344-.36.812-.563 1.3-.563H72.02c.487 0 .955.203 1.3.563.344.36.538.85.538 1.359v40.01c0 .51-.194.999-.538 1.36-.345.36-.813.562-1.3.562h-8.247v13.483a5.795 5.795 0 0 1-1.604 3.973A5.299 5.299 0 0 1 58.357 94a5.299 5.299 0 0 1-3.813-1.641 5.795 5.795 0 0 1-1.604-3.973Zm23.226-28.673V36.705a5.795 5.795 0 0 1 1.604-3.972 5.299 5.299 0 0 1 3.813-1.641c1.428 0 2.799.59 3.813 1.64A5.796 5.796 0 0 1 87 36.707v23.007a5.796 5.796 0 0 1-1.604 3.973 5.299 5.299 0 0 1-3.813 1.641 5.299 5.299 0 0 1-3.813-1.641 5.795 5.795 0 0 1-1.604-3.973Zm-63.278-21.02L.905 19.395a5.812 5.812 0 0 1-.806-2.059 5.919 5.919 0 0 1 .014-2.224c.145-.734.428-1.43.832-2.048a5.54 5.54 0 0 1 1.522-1.554 5.282 5.282 0 0 1 1.977-.822 5.185 5.185 0 0 1 2.127.038c.7.16 1.363.462 1.95.891.587.43 1.086.976 1.47 1.608l11.983 19.297a5.81 5.81 0 0 1 .811 2.06 5.918 5.918 0 0 1-.011 2.227 5.804 5.804 0 0 1-.832 2.05 5.539 5.539 0 0 1-1.524 1.557 5.283 5.283 0 0 1-1.98.822 5.166 5.166 0 0 1-2.13-.04 5.304 5.304 0 0 1-1.95-.894 5.567 5.567 0 0 1-1.47-1.613Zm13.877-10.448c-.274 0-.545-.064-.792-.187a1.856 1.856 0 0 1-.638-.525 1.96 1.96 0 0 1-.36-.76 2.01 2.01 0 0 1-.012-.85 26.471 26.471 0 0 1 4.265-9.959 25.146 25.146 0 0 1 7.811-7.236l-3.828-7.225a1.053 1.053 0 0 1-.083-.77c.07-.258.236-.476.46-.606a.93.93 0 0 1 .737-.088.977.977 0 0 1 .58.483l3.857 7.277A23.87 23.87 0 0 1 49.154 5.41c3.588 0 7.134.815 10.392 2.39L63.403.521a.977.977 0 0 1 .58-.482.928.928 0 0 1 .736.087.98.98 0 0 1 .288.255 1.058 1.058 0 0 1 .09 1.121l-3.83 7.225a25.147 25.147 0 0 1 7.811 7.237 26.472 26.472 0 0 1 4.264 9.96c.056.28.052.57-.012.849a1.961 1.961 0 0 1-.36.76c-.172.222-.39.402-.638.525a1.773 1.773 0 0 1-.791.187l-44.776-.002ZM58.349 17.48c0 .43.122.852.351 1.21.229.358.554.637.935.802.38.165.799.208 1.203.124a2.056 2.056 0 0 0 1.066-.596 2.21 2.21 0 0 0 .57-1.115 2.27 2.27 0 0 0-.119-1.258 2.16 2.16 0 0 0-.767-.977 2.018 2.018 0 0 0-1.157-.367c-.551 0-1.08.23-1.47.638-.39.409-.61.962-.61 1.54h-.002Zm-22.56 0c0 .43.123.852.352 1.21.228.358.553.637.934.802.38.165.8.208 1.203.124a2.055 2.055 0 0 0 1.066-.596 2.21 2.21 0 0 0 .57-1.115c.08-.422.04-.86-.118-1.258a2.159 2.159 0 0 0-.767-.977 2.018 2.018 0 0 0-1.157-.367c-.552 0-1.08.23-1.47.638-.391.409-.61.962-.61 1.54h-.002Z" />
							</svg>
						</div>
						<Image
							src="/images/jupiter/global/action-app-download.png"
							width={342}
							height={204}
							alt=""
						/>
					</div>
				</div>
			) : null}
			{isBefore ? (
				<div className={style.actionItem}>
					<div className={style.actionInfo}>
						<div className={style.title}>{t('lbl_ReadytoPlay')}</div>
						<div className={style.button}>
							<Button
								className={jupiterButton()}
								onClick={() => signUpService.displaySignUpModal(true)}
							>
								{t('lbl_Go')}
							</Button>
						</div>
					</div>
					<div className={style.actionImage}>
						<BackgroundImage />
						<Image
							src="/images/jupiter/global/action-sign-in.png"
							width={342}
							height={204}
							alt=""
						/>
					</div>
				</div>
			) : null}
		</section>
	)
}

const BackgroundImage = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="348" height="204" fill="var(--colors-jupiter-site-primary-fixed)" viewBox="0 0 348 204">
		<path d="M255.062 52.335h72.052L195.527 203.999h-72.052z" opacity=".8" />
		<path d="M240.933 8.544h72.052L178.618 163.412h-72.052zm63.014 123.896h14.598l-53.746 61.947H250.2z" opacity=".3" />
		<path d="M151.973 77.969h14.598L57.224 203.999H42.626z" opacity=".8" />
		<path d="M96.373 65.152h39.847l-7.274 8.383H89.1zM83.645 79.823h39.847l-7.274 8.383H76.371zm-12.729 14.67h39.847l-7.274 8.383H63.642zm-12.728 14.671h39.847l-7.274 8.383H50.914zM45.46 123.835h39.847l-7.274 8.383H38.186zm-12.73 14.67h39.847l-7.274 8.383H25.456zm-12.728 14.671h39.847l-7.274 8.383H12.728zM7.273 167.847H47.12l-7.274 8.383H0z" opacity=".5" />
	</svg>
)